import {createContext, use} from 'react'
import {pullRequestsOverviewIndexRoute, pullRequestsOverviewRoute} from '../../../routes/overview-route'

// Overview mounts at its own `/overview` route and, when it replaces the conversation, at the PR  index route (`/pull/:number`).
// Data hooks read whichever the active entrypoint injects here rather than hardcoding a single route (reading an unmounted route throws).
export type OverviewRoute = typeof pullRequestsOverviewRoute | typeof pullRequestsOverviewIndexRoute

export const OverviewRouteContext = createContext<OverviewRoute>(pullRequestsOverviewRoute)

export function useOverviewRoute() {
  return use(OverviewRouteContext)
}
